import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import userConstant from '../../../assets/user-activities-table.json';

@Component({
    selector: 'haven-grid',
    templateUrl: './haven-grid.component.html',
    styleUrl: './haven-grid.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class HavenGridComponent implements OnChanges, OnInit{
  @Input() data;
  @Input() loadMoreInfo;
  @Input() isLoading;
  @Input() isLoadingFooter;
  @Output() loadMore = new EventEmitter();
  userLiterals;

  ngOnInit(): void {
    this.userLiterals = userConstant;
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  loadMoreDataClick() {
    this.loadMore.emit();
  }
}
